import api from './api';

export const qualityManagementService = {

  /** Search Trello for a card by batch/card number in Printing Out & Internal Rejection lists */
  searchCard: async (batchNumber: string) => {
    const response = await api.get('/quality-management/search-card', {
      params: { batch_number: batchNumber },
    });
    return response.data;
  },

  /** Get all reviews (admin view) */
  getAll: async (params?: {
    status?: string;
    assigned_to?: string;
    rejection_type?: string;
    search?: string;
  }) => {
    const response = await api.get('/quality-management', { params });
    return response.data;
  },

  exportAllCsv: async (params?: {
    status?: string;
    assigned_to?: string;
    rejection_type?: string;
    search?: string;
  }) => {
    const response = await api.get('/quality-management/export-csv', {
      params,
      responseType: 'blob',
    });
    return response;
  },

  /** Get reviews assigned to the logged-in user */
  getMyAssignments: async () => {
    const response = await api.get('/quality-management/my-assignments');
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/quality-management/${id}`);
    return response.data;
  },

  getResubmissionHistoryByReview: async (id: number) => {
    const response = await api.get(`/quality-management/${id}/resubmission-history`);
    return response.data;
  },

  getResubmissionHistoryByBatch: async (batchNumber: string) => {
    const response = await api.get('/quality-management/resubmission-history', {
      params: { batch_number: batchNumber },
    });
    return response.data;
  },

  getStats: async () => {
    const response = await api.get('/quality-management/stats');
    return response.data;
  },

  create: async (data: {
    trello_card_id?: string;
    trello_card_name?: string;
    batch_number: string;
    source_list_name?: string;
    source_board_name?: string;
    main_rejection_type: 'internal_ocl' | 'external_customer';
    sub_rejection_type: 'printing_department' | 'other_department';
    machine_type: 'rotary' | 'digital';
    issue_type?: 'color' | 'layout';
    external_issues?: string[];
    external_other_issue?: string;
    description?: string;
    action_plan?: string;
  }) => {
    const response = await api.post('/quality-management', data);
    return response.data;
  },

  resubmit: async (id: number, data: {
    main_rejection_type: 'internal_ocl' | 'external_customer';
    sub_rejection_type: 'printing_department' | 'other_department';
    machine_type: 'rotary' | 'digital';
    issue_type?: 'color' | 'layout';
    external_issues?: string[];
    external_other_issue?: string;
    description?: string;
    action_plan?: string;
    resubmission_note?: string;
  }) => {
    const response = await api.post(`/quality-management/${id}/resubmit`, data);
    return response.data;
  },

  updateStatus: async (id: number, status: string) => {
    const response = await api.patch(`/quality-management/${id}/status`, { status });
    return response.data;
  },

  deleteReview: async (id: number) => {
    const response = await api.delete(`/quality-management/${id}`);
    return response.data;
  },

  /** Submit 6M analysis for an internal review */
  submit6M: async (id: number, data: { category: string; [key: string]: any }) => {
    const response = await api.post(`/quality-management/${id}/6m-analysis`, data);
    return response.data;
  },

  /** Report as no issue found */
  submitNoIssue: async (id: number, remarks: string) => {
    const response = await api.post(`/quality-management/${id}/no-issue`, { remarks });
    return response.data;
  },

  /** Update external rejection details */
  updateExternalRejection: async (id: number, data: { external_issues?: string[]; description?: string; action_plan?: string }) => {
    const response = await api.patch(`/quality-management/${id}/external-rejection`, data);
    return response.data;
  },

  /** Approve the current step in the approval chain */
  approve: async (id: number) => {
    const response = await api.post(`/quality-management/${id}/approve`);
    return response.data;
  },

  /** Get reviews pending logged-in user's approval */
  getPendingApprovals: async () => {
    const response = await api.get('/quality-management/pending-approvals');
    return response.data;
  },
};

export default qualityManagementService;
